import React from 'react';
import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset-advanced';

const GlobalStyle = createGlobalStyle`
    ${reset}
    
    :root {
      --header-height: 90px;
      --header-height-mobile: 60px;
    }

    *,
    *:before,
    *:after {
        box-sizing: border-box;
        -webkit-font-smoothing: antialiased;
        user-select: initial;
    }

    html {
        overflow-x: hidden;
    }

    html {
        font-family: ${({ theme }) => theme.fonts.body};
        scroll-behavior: smooth;
    }

    body {
        background-color: #fff;
        color: ${({ theme }) => theme.colors.primary[1800]};
    }

    #gatsby-focus-wrapper {
      height: 100vh;
      display: flex;
      flex-direction: column;
    }
    
    main {
      flex: 1
    }

    :focus-visible {
        outline: 2px dotted ${({ theme }) => theme.colors.primary.main};
        outline-offset: 2px;
    }

    h1, h2, h3, h4, h5, h6 {
        font-family: ${({ theme }) => theme.fonts.heading};
        line-height: 1.2;   
    }

    p a:not([class]) {
        border-bottom: 1px solid currentColor;
    }
    
    input, textarea {
      font-family: Lato, system-ui, sans-serif;
    }
    
    img, iframe {
      width: 100%;
      max-width: 100%;
      display: block;
    }

`;

export default function GlobalStylesWrapper({ children }) {
    return (
        <>
            <GlobalStyle />
            {children}
        </>
    );
}
